export default "__VITE_ASSET__COIcHd8x__"